module.exports = __webpack_public_path__ + "img/logo-coppa.173fc24f.png";